import { DEFAULT_NOTIFICATION_COLOR } from "../constant/index";

/**
 * Get background color for notification
 * @param {string} color - Color code without #
 * @returns {string} - Color with # prefix
 */
export const getColorForNotification = (color) => {
    return color?.trim()?.length > 0 ? "#" + color : DEFAULT_NOTIFICATION_COLOR;
};

/**
 * Fetch binary file and convert to base64
 * @param {string} url - File URL
 * @returns {Promise<string>} - Base64 data
 */
export const fetchBinaryFile = async (url) => {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const blob = await response.blob();
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise((resolve) => {
        reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
        };
    });
};

/**
 * Parse detail string from API to JSON
 * @param {string} detail - Detail string with single quotes
 * @returns {Object} - Parsed JSON object
 */
export const parseDetailToJson = (detail) => {
    const stringToJson = detail?.replaceAll("'", '"');
    const infoEvent = stringToJson ? JSON.parse(stringToJson) : {};
    return infoEvent;
};

/**
 * Check if camera has specific AI service registered and active
 * @param {Object} item - Camera item
 * @param {string} aiServiceCode - AI service code to check
 * @returns {boolean} - True if service is registered and active
 */
export const hasActiveAiService = (item, aiServiceCode) => {
    return (
        item?.list_ai_service_registed?.some(
            (sv) => sv?.ai_service_code === aiServiceCode
        ) &&
        item?.list_ai_service?.find((sv) => sv?.ai_service_code === aiServiceCode)
            ?.status === 1
    );
};

/**
 * Create empty event info object
 * @returns {Object} - Empty event info
 */
export const createEmptyEventInfo = () => ({
    time: "",
    object: "",
    info: "",
    image: "",
    show: false,
});

/**
 * Calculate position coordinates based on percentage
 * @param {Array} roiList - ROI list with percentage coordinates
 * @param {number} width - Container width
 * @param {number} height - Container height
 * @returns {Array} - Absolute coordinates
 */
export const calculatePositionCoordinates = (roiList, width, height) => {
    if (!roiList || !roiList[0]) return null;
    return roiList[0].map((item) => [
        (item[0] * width) / 100,
        (item[1] * height) / 100,
    ]);
};

